module.exports = __webpack_public_path__ + "img/blue-booth-table-6.c07afb0b.png";